import { render } from "./LaunchPage.vue?vue&type=template&id=196cd7e0&scoped=true"
import script from "./LaunchPage.vue?vue&type=script&lang=js"
export * from "./LaunchPage.vue?vue&type=script&lang=js"

import "./LaunchPage.vue?vue&type=style&index=0&id=196cd7e0&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196cd7e0"]])

export default __exports__